import { AxiosRequestConfig } from "axios";
import { jkRestReturnClass } from "./jkClass";
import { jkLib } from "./jkCommon";
import { JkJobOption, JkJobKind, jkRestReturn, idNameItem } from "./jkInterface";
import { JkBaseOption } from "./jkOption";
import { OrmService } from "./jkOrm";
import { login, LoginService } from "./jkUser";
import { PageService } from "./page.service";
import { inject } from "@angular/core";

//TCheckBox,TjkCheckBox: Y/N  TJKBtnEdit,TEdit,TJKDBEdit:text TjkMultiSelect: A||B...
export const jobParamKindList: idNameItem[] = [
  { id: 'TjkCheckBox', name: '勾選' },
  { id: 'TjkComboBox', name: '下拉' },
  { id: 'TComboBox', name: '下拉2' },
  { id: 'TJKRange', name: '範圍' },
  { id: 'TjkMultiSelect', name: '多選' },
  { id: 'TJKDBEdit', name: '單行' },
  { id: 'query', name: 'url參數' },
  { id: 'body', name: 'body參數' },
  { id: 'method', name: '方法' },
  { id: 'host', name: '主機網址' }, // 含http,port
  { id: 'path', name: '路徑' },
];

export const JkJobOptionColumns: string[] = [
  'btn',
  'kind',
  'caption',
  'text',
  'name',
  'type',
  'ps',
  'ps2',
];

export class JobMailOption extends JkBaseOption { // ###
  mailFrom: string;
  mailTo: string;
  mailName: string;
  login: LoginService; // = inject(LoginService);
  constructor(name: string) {
    super(name);
    this.login= login;
    this.mailFrom= this.login.EMAIL;
    this.mailTo = this.login.EMAIL;
    this.mailName = this.login.name;
  }
}

export class JkJobService {

  options: JkJobOption[] = []; //Array<JkJobOption>;
  //progId: string;
  //kind: string; // 批次 報表 API
  //notify: string; //空白 或 3    空白:不通知  1:有錯誤通知 2:有錯誤或警告通知 3:完成就通知
  public page: PageService = inject(PageService);
  public orm: OrmService= inject(OrmService);
  public login: LoginService;// = inject(LoginService);
  constructor() {
    //this.progId = xProgId.toLowerCase();
    //this.kind = xKind;
    this.login= login;
  };
  addOption(xName: string, xCaption: string, xKind: string, xData: string, xType: string,xPs: string) {
    let opt: JkJobOption = {name:xName,
      caption:xCaption,
      ps:xPs,
      kind:xKind,
      type:xType,
      text:xData
    }; //new JkJobOption();
    this.options.push(opt);
  };
  addOptionMultiSelect(xName: string, xCaption: string, xData: idNameItem[], xType: string,xPs: string) {
    let cList = xData.map((item) => item.id);

    let opt: JkJobOption = {name:xName,
      caption:xCaption,
      ps:xPs,
      kind:'TjkMultiSelect',
      type:xType,
      text:cList.join(",")
    }; //new JkJobOption();
    this.options.push(opt);
  };
  /**
   *
   * @param host
   * @param notify 空白:不通知  1:有錯誤通知 2:有錯誤或警告通知 3:完成就通知
   * @returns
   */
  async jobInsert(notify: string,progId:string,kind:JkJobKind):Promise<jkRestReturn>  {
      let ret: jkRestReturn = new jkRestReturnClass();

      let url = "/db/job_insert?date=" + jkLib.nowDate() + "&time=" + jkLib.nowTime4() +
        "&computerName="+this.orm.ip()+"&jobid="+
        "&dbname=" + this.login.dbname + "&progid=" + progId.toUpperCase() + "&kind=" + kind.toUpperCase() + "&userid=" + this.login.userid + "&notify=" + notify +
          "&email=" + (this.login.EMAIL == undefined ? "" : this.login.EMAIL);
      let config: AxiosRequestConfig = jkLib.axiosConfigInit(
        this.login.host,
        url,
        'post',
        '',
        this.options
      );

      let bool = await jkLib.doAxios(config, ret);
      if(!bool) {
        alert(ret.errorLog);
        //this.page.doShowJson(ret.request);
      }
      return ret;

  };
  convertToXmlStr(data: any,optName:string): string {
    // 處理 BatchOption 物件
    let xml = `<${optName}>`;

    // 遍歷 BatchOption 中的所有屬性
    for (const [key, value] of Object.entries(data.BatchOption)) {
      const items = value as any[];
      items.forEach((item) => {
        xml += `<${key}`;

        // 處理屬性
        if (item.$) {
          for (const [attrKey, attrValue] of Object.entries(item.$)) {
            xml += ` ${attrKey}="${attrValue}"`;
          }
        }

        xml += '>';

        // 處理元素值
        if (item._ !== undefined) {
          xml += item._;
        }

        xml += `</${key}>`;
      });
    }

    xml += `</${optName}>`;
    return xml;
  }
  apiToItemList(
    apiMethod: string,
    apiUrl: string,
    body: any,
    ret: jkRestReturn
  ): JkJobOption[] {
    ret.clear(true);
    let itemList: JkJobOption[] = [];
    if (apiMethod) {
      itemList.push({
        name: 'method',
        caption: '方法',
        kind: 'method',
        text: apiMethod,
        type: 'string',
        ps: apiUrl,
      });
    }
    if (apiUrl) {
      const parsed = jkLib.parseUrl(apiUrl);

      if (parsed.ok) {
        // host (含協定與 port)
        itemList.push({
          name: 'host',
          caption: '主機網址',
          kind: 'host',
          text: parsed.hostWithProtocol,
          type: 'string',
          ps: '',
        });

        // path
        itemList.push({
          name: 'path',
          caption: '路徑',
          kind: 'path',
          text: parsed.path,
          type: 'string',
          ps: '',
        });

        // query 參數
        Object.keys(parsed.query).forEach((key) => {
          itemList.push({
            name: key,
            caption: key,
            kind: 'query',
            text: parsed.query[key],
            type: 'string',
            ps: parsed.rawQuery, // 可放整體原始 query (可自行決定要不要)
          });
        });
      } else {
        if (apiUrl) {
          // 無法解析但仍保留原字串
          itemList.push({
            name: 'host',
            caption: '主機網址',
            kind: 'host',
            text: apiUrl,
            type: 'string',
            ps: '未能完整解析',
          });
        }
      }
      if (body && typeof body === 'object') {
        // query 參數
        Object.keys(body).forEach((key) => {
          const type = typeof body[key];
          let text = '';
          if (type === 'string') text = body[key];
          else if (type === 'number' || type === 'boolean')
            text = body[key].toString();
          else text = JSON.stringify(body[key]);
          itemList.push({
            name: key,
            caption: key,
            kind: 'body',
            text: text,
            type: type,
            ps: '', // 可放整體原始 query (可自行決定要不要)
          });
        });
      }
    }
    return itemList;
  }
  itemListToApi(itemList: JkJobOption[]): {
    ok: boolean;
    method?: string;
    url?: string;
    body?: any;
  } {
    let ret: {
      ok: boolean;
      method?: string;
      url?: string;
      body?: any;
    } = {
      ok: false,
    };
    let method: string | undefined;
    let url: string | undefined;
    let body: any | undefined;
    itemList.forEach((opt) => {
      if (opt.kind === 'method') {
        method = opt.text;
      } else if (opt.kind === 'host') {
        url = opt.text;
      } else if (opt.kind === 'path') {
        url = url + opt.text;
      } else if (opt.kind === 'query') {
        if (!url) url = '';
        url =
          url +
          (url.indexOf('?') === -1 ? '?' : '&') +
          opt.name +
          '=' +
          opt.text;
      } else if (opt.kind === 'body') {
        if (!body) body = {};
        body[opt.name] = opt.text;
      }
    });
    ret.ok = true;
    ret.method = method;
    ret.url = url;
    ret.body = body;

    return ret;
  }

}

/*
export class JkOptionClass {
  constructor() {
  };
  scrollViewOption() // DevExpress.ui.dxScrollableOptions =
  {
    return { direction: 'vertical', bounceEnabled: false, showScrollbar: 'always', scrollByContent: true, };
  };
  doHomeOption(xHome: any){
    return { accessKey: 'H', hint: 'Alt-H:回首頁', onClick: xHome, text: '回首頁(H)', visible: true, icon: 'home' };
  }
  doBackOption(xBack: any){
    return { accessKey: 'B', hint: 'Alt-B:回上頁',  text: '回上頁',  visible: true,  onClick: xBack , icon: 'back' }
  }
  doFilterOption(xFilter: any){
    return { accessKey: 'Q', hint: 'Alt-Q:用條件選項重查',  text: '重查',  visible: true,  onClick: xFilter , icon: 'filter' }
  }
  doBatchPostOption(xInsert: any) {
    //let a: DevExpress.ui.dxButtonOptions = { accessKey: 'A' };
    return { accessKey: 'S', hint: 'Alt-S:整張存檔', onClick: xInsert, text: '整張存檔(S)', visible: true, icon: 'save' };
  };
  doInsertOption(xInsert: any) {
    //let a: DevExpress.ui.dxButtonOptions = { accessKey: 'A' };
    return { accessKey: 'A', hint: 'Alt-A:新增資料', onClick: xInsert, text: '新增(A)', visible: true, icon: 'plus' };
  };
  doRefreshOption(xFunc: any) // DevExpress.ui.dxButtonOptions =
  {
    return { accessKey: 'R', hint: 'Alt-Q:重查資料', onClick: xFunc, text: '重查(Q)', visible: true, icon: 'search' };
  };
  doEditOption(xFunc: any) //DevExpress.ui.dxButtonOptions =
  {
    return { accessKey: 'E', hint: 'Alt-E:修改資料', onClick: xFunc, text: '修改(E)', visible: true, icon: 'edit' };
  };
  doDeleteOption(xFunc: any) { //DevExpress.ui.dxButtonOptions =
    return { accessKey: 'R', hint: 'Alt-R:刪除資料', onClick: xFunc, text: '刪除(R)', visible: true, icon: 'remove' };
  };
  doOkOption(xFunc: any) {
    return { accessKey: 'O', hint: 'Alt-O:確定', text: '確定(O)', onClick: xFunc, icon: 'todo' };
  };
  doCancelOption(xFunc: any) {
    return { accessKey: 'C', hint: 'Alt-C:取消', text: '取消(C)', onClick: xFunc, icon: 'close' };
  };
};
*/
